import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  gap: 2rem;
`;

export const DivSelect = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.large}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SelectField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 27rem;
  max-width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.size?.large}) {
    width: 100%;
  }
`;

export const DivSend = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.large}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const CheckboxDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 30rem;
  min-width: 0;
  color: ${({ theme }) => theme.colors?.primary};
  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.large}) {
    flex: 0 0 auto;
  }
`;

export const ButtonSlot = styled.div`
  width: 18.5rem;
  max-width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.size?.large}) {
    width: 100%;
  }
`;

export const ReferenceCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
`;

export const CourseName = styled.span`
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

export const H6 = styled.h6`
  color: ${({ theme }) => theme.colors?.danger};
`;

export const TermButton = styled.a`
  font-weight: bold;
  width: 13rem;
  padding-left: 2rem;
  cursor: pointer;
`;
